import React, { memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import BlurAmountView from 'design-system/BlurAmountView';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import RadioButton from 'design-system/RadioButton';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { isWeb } from '../../../constants';
const TransferAccountRow = ({ name, Icon, desc, amount, onPress, selected, disabled, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    return (<TouchableHighlight onPress={onPress} activeOpacity={1} disabled={disabled} underlayColor={colors.background.underlay} onCard hoverOnLight 
    // On web the row sits 8 inside the modal edge, so its hover doesn't reach the edge
    {...(isWeb && { style: styles.webRow })}>
      <View style={[
            styles.container,
            ...(isWeb ? [styles.webContainer] : []),
            disabled && styles.disabled,
        ]}>
        <RadioButton type="single" isChecked={selected}/>
        <Spacer w={16}/>
        <View style={styles.iconContainer}>{Icon}</View>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {name}
          </Text>
          {!!desc &&
            (typeof desc === 'string' ? (<Text TextThin-14 Secondary numberOfLines={1}>
                {desc}
              </Text>) : (desc))}
        </View>
        {!!amount && (<>
            <Spacer w={16}/>
            <BlurAmountView enabled={scrambled}>
              {React.isValidElement(amount) ? (amount) : (<Text Numbers-16>
                  {formatAmount(amount.value, amount.currency, 2)}
                </Text>)}
            </BlurAmountView>
          </>)}
      </View>
    </TouchableHighlight>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    webRow: {
        marginHorizontal: rem(8),
    },
    webContainer: {
        paddingHorizontal: rem(8),
    },
    flex: {
        flex: 1,
    },
    iconContainer: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        borderRadius: rem(44),
        justifyContent: 'center',
        backgroundColor: colors.background.dark,
    },
    disabled: {
        opacity: 0.5,
    },
}));
export default memo(TransferAccountRow);
